export default {
  list: [
    {
      value: 'NO_ANSWER',
      title: 'نظرهای بدون پاسخ'
    },
    {
      value: 'ANSWER_BY_RSEE',
      title: 'نظرهای پاسخ داده شده توسط آرسی'
    },
    {
      value: 'ANSWER_BY_CAFE_ADMIN',
      title: 'نظرهای پاسخ داده شده توسط مدیر کافی‌شاپ'
    },
    {
      value: 'ANSWER_BY_BOTH',
      title: 'نظرهای پاسخ داده شده توسط آرسی و مدیر کافی‌شاپ'
    }
  ],
  values: {
    ANSWER_BY_BOTH: 'ANSWER_BY_BOTH',
    ANSWER_BY_CAFE_ADMIN: 'ANSWER_BY_CAFE_ADMIN',
    ANSWER_BY_RSEE: 'ANSWER_BY_RSEE',
    NO_ANSWER: 'NO_ANSWER'
  }
};
